module.exports = __webpack_public_path__ + "static/media/ios-1.dc8d9804.jpg";